<template>
  <v-card class="mx-4 rounded-card">
    <v-container>
      <v-layout column>
        <form>
          <v-text-field
            v-model="i_email"
            single-line
            outline
            type="email"
            autocomplete="username"
            :class="emailErrors.length > 0 ? 'input-field-error' : 'my-2 input-field'"
            :background-color="emailErrors.length > 0 ? '' : 'grey lighten-2'"
            :error-messages="emailErrors"
            :hide-details="emailErrors.length === 0"
            :disabled="isCreatingAccount || accountCreated"
            @blur="$v.i_email.$touch()"
          >
            <template v-slot:label>
              <span v-if="emailErrors.length > 0" class="input-label-error">Email address here</span>
              <span v-else class="input-label">Email address here</span>
            </template>
          </v-text-field>
          <v-checkbox :disabled="isCreatingAccount || accountCreated" class="mt-0" hide-details color="#2c7fff" v-model="checkbox">
            <template v-slot:label>
              <span class="email-optin">I want to receive by email the latest news and offers from MWM.</span>
            </template>
          </v-checkbox>
          <v-flex class="mt-3">
            <v-btn v-if="accountCreated" class="rounded-button-done" color="#4caf50" type="submit" flat block disabled>
              <template v-slot:default>
                <span class="create-button">ACCOUNT CREATED!</span>
              </template>
            </v-btn>
            <v-btn v-else class="rounded-button" color="#2c7fff" type="submit" block
              :disabled="isCreatingAccount"
              :loading="isCreatingAccount"
              @click.stop="register"
            >
              <template v-slot:default>
                <span class="create-button">START</span>
              </template>
            </v-btn>
          </v-flex>
          <v-flex class="my-2" v-if="registerStatus === 'error'">
            <span class="error-message">{{ registerErrorMessage }}</span>
          </v-flex>
          <v-flex class="mt-2">
            <div class="create-terms">By continuing, you agree to <a class="create-link" @click="goto('/tos')">MWM's Terms</a></div>
            <div class="create-terms"><a class="create-link" @click="goto('/tos')">of services</a> and <a class="create-link" @click="goto('/pp')">Privacy Policy</a></div>
          </v-flex>
        </form>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  import { required, minLength, email } from 'vuelidate/lib/validators'

  export default {
    props: ['register_key'],
    data () {
      return {
        checkbox: false,

        i_email: '',

        timeout: null,
      }
    },
    validations: {
      i_email: { required, email }
    },
    methods: {
      goto (path) {
        this.$router.push(path)
      },
      register () {
        this.$store.commit('REGISTRATION_STATUS_SET', 'idle')
        this.$store.commit('REGISTRATION_ERROR_SET', { body: { message: '' } })

        this.$v.$touch()

        if (this.$v.$invalid) {
          this.$store.commit('REGISTRATION_STATUS_SET', 'error')
          this.$store.commit('REGISTRATION_ERROR_SET', { body: { message: 'form error' } })
        } else {
          this.sendEvent('clicked_button', 'landing_' + this.register_key + '_card_cta')
          let payload = {
            env: this.env,
            body: {
              app_key: this.appKey,
              device_type: this.deviceType,
              installation_id: this.sessionId,
              email: this.i_email,
              lang: 'US',
              accept_terms: this.checkbox
            }
          }
          this.$store.dispatch('REGISTER', payload)
            .then((response) => {
              this.$session.set(this.userInstanceIdStorageKey, response.user_instance_id);
              this.$session.set(this.accessTokenStorageKey, response.access_token);
              this.$session.set(this.accessTokenExpirationTimeStorageKey, response.access_token_expiration_time);
              this.$session.set(this.refreshTokenStorageKey, response.refresh_token);
            })
            .catch((error) => console.log(error))
        }
      },
      sendEvent (type, value) {
        let payload = {
          env: this.env,
          headers: { appKey: this.appKey, offer: this.offer, version: this.version },
          body: {
            session_id: this.sessionId,
            layout_id: this.layoutId,
            user_instance_id: this.userInstanceId,
            type: type,
            value: value,
          }
        }
        this.$store.dispatch('EVENT_SEND', payload)
      }
    },
    computed: {
      ...mapGetters([
        'env',

        'appKey',
        'offer',
        'version',
        'deviceType',
        'sessionId',
        'layoutId',
        'userInstanceId',

        'registerStatus',
        'registerErrorMessage',

        'userInstanceIdStorageKey',
        'accessTokenStorageKey',
        'accessTokenExpirationTimeStorageKey',
        'refreshTokenStorageKey',
      ]),
      isCreatingAccount () {
        return this.registerStatus === 'progress'
      },
      accountCreated () {
        return this.registerStatus === 'done'
      },
      emailErrors () {
        let errors = []
        if (!this.$v.i_email.$dirty) return errors
        !this.$v.i_email.email && errors.push('Must be valid email.')
        !this.$v.i_email.required && errors.push('An email is required.')
        return errors
      },
    },
    mounted () {
      this.$nextTick(function () {

      })
    },
    watch: {
      registerStatus (newVal) {
        if (newVal === 'done') {
          this.$store.commit('STORE_MODE_SET', 'creation')
          let thiz = this
          this.timeout = setTimeout(() => {
            thiz.$router.push('/store')
            clearTimeout(thiz.timeout)
          }, 1000)
        }
      }
    }
  }
</script>

<style scoped>
.rounded-card{
  border-radius:11px;
}

.input-label {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #abadad;
}

.input-label-error {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: red;
}

.input-field {
  font-family: CenturyGothic;
  font-size: 18px;
  background-color: #f8f8f8;
}

.input-field-error {
  font-family: CenturyGothic;
  font-size: 18px;
  background-color: #f8f8f8;
}

.email-optin {
  font-family: CenturyGothic;
  font-size: 9px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.rounded-button {
  border-radius: 11px;
  height: 72px;
  background-color: #2c7fff;
}

.rounded-button-done {
  border-radius: 11px;
  height: 72px;
  background-color: #4caf50;
}

.create-button {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: #ffffff;
}

.create-button-disabled {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: grey;
}

.create-terms {
  font-family: CenturyGothic;
  font-size: 9px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.create-terms .create-link {
  color: #2c7fff;
}

.error-message {
  font-family: CenturyGothic;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: red;
}
</style>
